module.exports = __webpack_public_path__ + "img/1c484b8.svg";